<template>
  <div id="content">
    <div class="basicInformation">
      <div class="typeArea">
        <h2 class="title">商标申请信息</h2>
        <el-form label-width="100px" label-position="left">
          <el-form-item
            label="申请号/注册号"
            style="display: block"
            :rules="[{ required: true, message: '请输入申请号/注册号', trigger: 'blur' }]"
          >
            <el-input
              :placeholder="`请输入商标申请号`"
              style="position: relative;"
              v-model="PFformLabelAlign.caseNumber"
            ></el-input>
            <el-button
              style="position: absolute; right: -40px; top: 3px; height: 35px; line-height: 11px; border-radius: 0px"
              type="primary"
              @click="query"
            >查询</el-button>
          </el-form-item>
          <el-row style="display: flex; flex-wrap:wrap;">
            <el-col>
              <el-form-item :label="`商标图样`">
                <img :src="PFformLabelAlign.type" alt width="50px" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-col :span="24">
            <el-form-item :label="`商标类别`">
              <el-input :placeholder="`请输入商标类别`" v-model="PFformLabelAlign.brandType" disabled></el-input>
              <el-button
                style="position: absolute; right: -40px; top: 3px; height: 35px; line-height: 11px; border-radius: 0px"
                type="primary"
              >分类</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="`申请人名称`">
              <el-input v-model="PFformLabelAlign.applicantName" :placeholder="`请自定义输入订单号`"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="`统一社会信用代码`">
              <el-input v-model="PFformLabelAlign.assistant" :placeholder="`请输入助理姓名`"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="`商标代理机构名称`">
              <el-input v-model="PFformLabelAlign.agent" :placeholder="`请输入商标名称`"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
    </div>
    <div class="footer">
      <div class="matter">
        <div class="num">
          <span>应付金额：</span>
          <i>￥</i>
          <span class="price">{{product.price}}</span>
        </div>
        <el-button @click="creatOrder(),changePFReview(),changePFProductList()">立即下单</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { enquiryNumber, getProductListCards, SCCode } from "@/api/fill.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      product: {},
      radio: "1",
      labelPosition: "right",
      PFformLabelAlign: {
        type: "", //商标图样
        caseNumber: "", //申请号/注册号
        agent: "", //  商标代理机构名称
        applicantName: "", //申请人名称
        assistant: "", //统一社会信用代码
        brandType: "", //商标类别
        price: "", //应付金额
      },
    };
  },
  computed: {
    ...mapState({
      PFreviewInfo: (state) => state.brandReview.PFreviewInfo,
      // PFproductList: (state) => state.brandReview.PFproductList,
    }),
  },

  created() {
    let params = "sbfu/zysbfs";
    getProductListCards(params).then((res) => {
      if (res.status == 0) {
        this.product = res.data[0] || {};
      } else if (res.status == -99) {
        window.localStorage.setItem("url", window.location.hash.split("#")[1]);
        this.$router.push("/login");
      } else {
        this.$message("请刷新页面重试!");
      }
    });
  },
  mounted() {
    this.$store.commit("qffillmaterials/changeActivedIndex", 0);
  },
  methods: {
    //申请号查询
    query() {
      let params = {
        regNum: this.PFformLabelAlign.caseNumber, //注册号
        sqlbtabkey: "", //申请类别
        flzttabkey: "", //法律状态
        sqnftabkey: "", //申请年份
        xcl: [], //商标群组
        pageSize: 20, //每页数量
        currentPage: 1, //当前页
      };
      if (this.PFformLabelAlign.caseNumber) {
        enquiryNumber(params).then((res) => {
          if (res.status == 0) {
            if (res.data.rows.length != 0) {
              let queryData = res.data.rows;
              this.PFformLabelAlign.type = queryData[0].logo; //商标
              this.PFformLabelAlign.applicantName = queryData[0].zcr;
              this.PFformLabelAlign.agent = queryData[0].dljg; //商标代理机构
              this.PFformLabelAlign.brandType = queryData[0].gjfl; //尼斯一级大类
              // 统一信用代码查询
              let paramSC = {
                company_name: this.PFformLabelAlign.applicantName,
              };
              SCCode(paramSC).then((res) => {
                if (res.status == 0) {
                  this.PFformLabelAlign.assistant = res.data.creditCode;
                } else {
                  this.PFformLabelAlign.assistant = "";
                }
              });
            } else {
              this.$message({
                message: "申请号/注册号有误，请核对后，重新输入",
                type: "warning",
              });
              this.PFformLabelAlign.type = ""; //商标
              this.PFformLabelAlign.applicantName = ""; //申请人名称
              this.PFformLabelAlign.brandType = ""; //商标类别
              this.PFformLabelAlign.agent = ""; // 商标代理机构
              this.PFformLabelAlign.assistant = ""; // 统一信用代码
            }
          }
        });
      } else {
        this.$message({ message: "申请号/注册号 不能为空", type: "warning" });
      }
    },
    //立即下单
    creatOrder() {
      if (!this.PFformLabelAlign.caseNumber) {
        this.$message({ message: "申请号/注册号 不能为空", type: "warning" });
      } else if (!this.PFformLabelAlign.applicantName) {
        this.$message({ message: "申请人名称不能为空", type: "warning" });
      } else if (!this.PFformLabelAlign.assistant) {
        this.$message({ message: "统一信用代码不能为空", type: "warning" });
      } else if (!this.PFformLabelAlign.agent) {
        this.$message({ message: "商标代理机构名称不能为空", type: "warning" });
      } else {
        this.$router.push("/brandReview/professional/PFapplicantInformation");
      }
    },
    changePFReview() {
      this.$store.commit("brandReview/changePFReview", this.PFformLabelAlign);
    },
    changePFProductList() {
      this.$store.commit("brandReview/changePFProductList", this.product);
    },
  },
};
</script>
<style lang="scss" scoped>
#content {
  width: 100%;
  padding-bottom: 10px;
  overflow: hidden;
  background-color: #f4f4f4;
  .basicInformation {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80%;
    background-color: #fff;
    border: 1px solid #ddd;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
    padding-bottom: 50px;
    .typeArea {
      width: 80%;
      .title {
        white-space: nowrap;
        font-size: 18px;
        font-weight: 900;
        height: 100%;
        margin-top: 30px;
      }
      .el-form {
        margin-top: 20px;
        margin-left: 20px;
        /deep/.el-form-item {
          display: inline-block;
          white-space: nowrap;
          width: 100%;
          margin-bottom: 12px;
          .el-form-item__label {
            margin-right: 40px;
          }
          .el-form-item__content {
            height: 30px;
            width: 60%;
            .el-input {
              display: inline-block;
              width: 100%;
              height: 35px;
              .el-input__inner {
                border-radius: 0px;
                display: inline-block;
                width: 100%;
                height: 35px;
              }
            }
          }
        }
        .demonstration {
          margin-right: 45px;
        }
        .el-date-editor {
          width: 62%;
          height: 40px;
        }
        /deep/.el-radio__inner {
          border-color: #bbb;
        }
        /deep/.el-input__inner {
          width: 102%;
          height: 35px;
          line-height: 35px;
          border-radius: 0px;
        }
        /deep/.el-input__icon {
          line-height: 35px;
        }
        /deep/.el-picker-panel .el-date-picker .el-popper {
          position: absolute;
          top: 509px;
        }
      }
    }
  }
  .footer {
    position: relative;
    bottom: -10px;
    width: 100%;
    height: 100px;
    background-color: #fff;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
    .matter {
      position: absolute;
      right: 190px;
      bottom: 22px;
      display: flex;
      align-items: center;
      .num {
        display: inline-block;
        i {
          color: #ff6a01;
        }
        .price {
          font-size: 28px;
          font-weight: 900;
          color: #ff6a01;
        }
      }
      .el-button {
        background-color: #ff6a01;
        font-size: 16px;
        width: 145px;
        height: 44px;
        color: #fff;
        margin-left: 30px;
        border-radius: 0px;
      }
    }
  }
}
</style>